let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jRFFA")).then(() => parcelRequire('hTW3c'));